import { useState } from 'react'
import { useTexte } from '../../texte'

import { useSetSchrift } from '../../hooks/queries'
import {
  SCHRIFTGROESSEN,
  gespeicherteGroesse,
  setzeGroesse,
  type Schriftgroesse,
} from '../../lib/darstellung'

/**
 * Wie groß die Schrift ist — in der ganzen Anwendung, auf allen Geräten.
 *
 * **Diese Karte steht bei jedem, nicht nur bei der Verwaltung.** Sie regelt
 * nichts an der Reise, sondern etwas an den Augen dessen, der davorsitzt.
 *
 * Sie hat einmal nur die Sprechblasen bewegt. Das war zu wenig: eine
 * Einstellung, die „Schriftgröße" heißt und nur den Chat anfasst, lässt
 * jeden Knopf und jede Karte so klein, wie sie waren.
 *
 * Und sie hing einmal nur am Gerät. Auch das war zu wenig: wer am iPad groß
 * stellte, saß am iPhone wieder klein.
 *
 * Die Wirkung ist sofort zu sehen, nicht erst nach einem „Sichern": eine
 * Schriftgröße, die man nicht sieht, während man sie wählt, wählt man blind.
 * Gesichert wird nebenher — **schlägt das fehl, steht es als Text da**, denn
 * eine Einstellung, die nur auf diesem Gerät gilt, obwohl sie überall gelten
 * sollte, merkt man sonst erst am nächsten.
 */
export function DarstellungCard() {
  const t = useTexte()
  const [gewaehlt, setGewaehlt] = useState<Schriftgroesse>(gespeicherteGroesse)
  const sichern = useSetSchrift()

  return (
    <div className="card card--seite">
      <h2 className="card__titel">{t.schrift.titel}</h2>
      <p className="card__lead">{t.schrift.lead}</p>

      <div className="schriftwahl" role="radiogroup" aria-label={t.schrift.wahl}>
        {SCHRIFTGROESSEN.map((stufe) => (
          <button
            key={stufe.wert}
            type="button"
            role="radio"
            aria-checked={gewaehlt === stufe.wert}
            className={
              gewaehlt === stufe.wert
                ? 'schriftwahl__knopf schriftwahl__knopf--an'
                : 'schriftwahl__knopf'
            }
            onClick={() => {
              setzeGroesse(stufe.wert)
              setGewaehlt(stufe.wert)
              sichern.mutate(stufe.wert)
            }}
          >
            <span className={`schriftwahl__probe schriftwahl__probe--${stufe.wert}`}>Aa</span>
            {stufe.name}
          </button>
        ))}
      </div>

      {sichern.isError && (
        <p className="form__error" role="alert">{t.schrift.nichtGemerkt}</p>
      )}
    </div>
  )
}
